export enum MailingType {
  Additional = "additional_mailing",
  ProxyMessage = "proxy_message",
}

export const SHORT_DATE_FORMAT = "MMM D";
export const SHORT_TIME_FORMAT = "h:mm A";
